import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './Components/Navbar/Navbar';
import Hero from './Components/Hero/Hero';
import Blogs from './Components/Blogs/Blogs';
import { blogsData } from './Components/Blogs/BlogsData';
import About from './Components/AboutMe/About';
import Certifications from './Components/Certifications/Certifications';
import Projects from './Components/Projects/Projects';
import Hackathons from './Components/Hackathons/Hackathons';
import BlogPage from './Components/Blogs/BlogPage';

function App() {
  return (
     <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/blogs" element={<Blogs blogsData={blogsData} />} />
          <Route path="/blog/:id" element={<BlogPage/>} />
          <Route path="/about" element={<About />}/>
          <Route path="/certifications" element={<Certifications/>}/>
          {/* <Route path="/experience" element={<Experience/>}/> */}
          <Route path="/" element={<Hero />} />
          <Route path='/projects' element={<Projects/>}/>
          <Route path='/hackathons' element={<Hackathons/>}/>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
